"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TemplateUnits = (function () {
    function TemplateUnits(createUi, getTemplateUnit, selectTemplate, results, templateState) {
        var selectTemplateUnit = function (result, message) {
            templateUnits.forEach(function (templateUnit) {
                templateUnit.active = templateUnit.projectId === result.projectId;
            });
            selectTemplate(message || "template selected", result);
        };
        var templateUnits = results.map(function (template, index) {
            return getTemplateUnit({
                template: template,
                index: index + 1,
                projectId: template.projectId,
                active: template.projectId === templateState.projectId,
                selectTemplate: selectTemplateUnit,
            });
        });
        this._ui = createUi(require("./TemplateUnits.html"), {
            searchTerm: templateState.searchTerm,
            isMyTemplates: templateState.dropdownItem === "my-templates",
            templateUnits: templateUnits,
        });
        if (!templateState.projectId && results && results.length > 0) {
            selectTemplateUnit(results[0], "first template set as default");
        }
    }
    Object.defineProperty(TemplateUnits.prototype, "ui", {
        get: function () {
            return this._ui;
        },
        enumerable: false,
        configurable: true
    });
    return TemplateUnits;
}());
exports.default = TemplateUnits;
